// extracted by mini-css-extract-plugin
export default {"navigation":"Menu_navigation__jFUUJ","logo":"Menu_logo__ghluZ","online":"Menu_online__Q6nsZ","offline":"Menu_offline__aCsGl"};